// Helpers for the standardized backend response envelope.
// Expected success shape: { success: true, data: <payload> }
// Expected error shape: { success: false, error: <message>, code?: <string> }
// These helpers accept either a raw Axios response object or an already-extracted
// response body so callers do not need to repeat `response.data` handling.

const getBody = (response) => response?.data ?? response

export const unwrapApiData = (response, fallback = null) => {
    const body = getBody(response)

    if (body && body.success === true) {
        return body.data ?? fallback
    }

    if (body && body.success === false) {
        return fallback
    }

    return body ?? fallback
}

export const getApiError = (response, fallback = 'Request failed') => {
    const body = getBody(response)

    if (body && typeof body.error === 'string' && body.error.length > 0) {
        return body.error
    }

    return fallback
}

export const isApiSuccess = (response) => getBody(response)?.success === true
